import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';

// Global guards only. Feature-specific checks live in each module's
// route `beforeEnter`.
export function setupRouterGuards(router) {
    router.beforeEach((to, _from, next) => {
        NProgress.start();
        const token = localStorage.getItem('gamingToken') || '';

        if (to.meta.requiresAuth && !token) {
            NProgress.done();
            next('/');
            Vue.nextTick(() => {
                const app = router.app;
                if (app) app.$root.$emit('open-login');
            });
            return;
        }

        next();
    });

    router.afterEach(() => {
        setTimeout(() => NProgress.done(), 100);
        if (!localStorage.getItem('gamingToken')) return;
        Vue.nextTick(() => {
            if (router.app) router.app.$root.$emit('fetch-member-info');
        });
    });
}

export function patchRouterPush() {
    const originalPush = Router.prototype.push;
    Router.prototype.push = function push(location) {
        return originalPush.call(this, location).catch(err => {
            if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected') && !err.message.includes('Aborted')) {
                return Promise.reject(err);
            }
        });
    };
}
